import GcAlertComponent from './GcAlert/index.vue';
import GcBrowserAlertComponent from './GcBrowserAlert/index.vue';
import GcButtonComponent from './GcButton/index.vue';
import GcCartCardComponent from './GcCartCard/index.vue';
import GcHorizontalLayoutComponent from './GcHorizontalLayout/index.vue';
import GcDropShadowComponent from './GcDropShadow/index.vue';
import GcFullImageComponent from './GcFullImage/index.vue';
import GcInputComponent from './GcInput/index.vue';
import GcReducedPriceComponent from './GcReducedPrice/index.vue';
import GcCopyComponent from './GcCopy/index.vue';
import GcLoaderComponent from './GcLoader/index.vue';
import GcCardContainerComponent from './GcCardContainer/index.vue';
import GcCardComponent from './GcCard/index.vue';
import GcDropDownComponent from './GcDropDown/index.vue';
import GcIconComponent from './GcIcon/index.vue';
import GcPhotoGridComponent from './GcPhotoGrid/index.vue';
import GcHeadingComponent from './GcHeading/index.vue';
import GcUtilityCartComponent from './GcUtilityCart/index.vue';
import GcIconNavComponent from './GcIconNav/index.vue';
import GcRadioComponent from './GcRadio/index.vue';
import GcDatePickerComponent from './GcDatePicker/index.vue';
import GcTooltipComponent from './GcTooltip/index.vue';

export const GcAlert = GcAlertComponent;
export const GcBrowserAlert = GcBrowserAlertComponent;
export const GcButton = GcButtonComponent;
export const GcCartCard = GcCartCardComponent;
export const GcHorizontalLayout = GcHorizontalLayoutComponent;
export const GcDropShadow = GcDropShadowComponent;
export const GcFullImage = GcFullImageComponent;
export const GcInput = GcInputComponent;
export const GcReducedPrice = GcReducedPriceComponent;
export const GcCopy = GcCopyComponent;
export const GcLoader = GcLoaderComponent;
export const GcCardContainer = GcCardContainerComponent;
export const GcCard = GcCardComponent;
export const GcDropDown = GcDropDownComponent;
export const GcIcon = GcIconComponent;
export const GcPhotoGrid = GcPhotoGridComponent;
export const GcHeading = GcHeadingComponent;
export const GcUtilityCart = GcUtilityCartComponent;
export const GcIconNav = GcIconNavComponent;
export const GcRadio = GcRadioComponent;
export const GcDatePicker = GcDatePickerComponent;
export const GcTooltip = GcTooltipComponent;
